// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-card-containers {
  width: 100%;
  display: flex;
  flex-direction: row; /* Align cards in a row */
  /* Spacing between cards */
  justify-content: center; /* Center cards */
  flex-wrap: nowrap; /* Prevent wrapping */
  gap:0px;
  overflow-x: auto; /* Allows scrolling if too many cards */
  
}

.card {
  background: white;
  
  border-radius: 10px;
  margin:10px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  width: 250px; /* Adjust width */
  display: flex;
  gap:20px;
  flex-direction: row; /* Align icon and content in a row */
  align-items: center; /* Vertically align icon and text */
}

.icon {
  font-size: 2.0rem;
  margin-right:10px;/* Space between icon and text */
}

.custom-icon {
  width: 50px;
  height: 50px;
   /* Space between icon and text */
}

.content {
  display: flex;
  flex-direction: column;
  text-align: left;
  
}

.value {
  font-size: 1.8rem;
  font-weight: bold;
  color: #3498db;
  
}

.label {
  font-size: 0.7rem;
  color: #555;
}
`, "",{"version":3,"sources":["webpack://./src/components/MyDashboard/Dashboardcard.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB,EAAE,yBAAyB;EAC9C,0BAA0B;EAC1B,uBAAuB,EAAE,iBAAiB;EAC1C,iBAAiB,EAAE,qBAAqB;EACxC,OAAO;EACP,gBAAgB,EAAE,uCAAuC;;AAE3D;;AAEA;EACE,iBAAiB;;EAEjB,mBAAmB;EACnB,WAAW;EACX,0CAA0C;EAC1C,YAAY,EAAE,iBAAiB;EAC/B,aAAa;EACb,QAAQ;EACR,mBAAmB,EAAE,oCAAoC;EACzD,mBAAmB,EAAE,mCAAmC;AAC1D;;AAEA;EACE,iBAAiB;EACjB,iBAAiB,CAAC,gCAAgC;AACpD;;AAEA;EACE,WAAW;EACX,YAAY;GACX,gCAAgC;AACnC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;;AAElB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;;AAEhB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb","sourcesContent":[".dashboard-card-containers {\n  width: 100%;\n  display: flex;\n  flex-direction: row; /* Align cards in a row */\n  /* Spacing between cards */\n  justify-content: center; /* Center cards */\n  flex-wrap: nowrap; /* Prevent wrapping */\n  gap:0px;\n  overflow-x: auto; /* Allows scrolling if too many cards */\n  \n}\n\n.card {\n  background: white;\n  \n  border-radius: 10px;\n  margin:10px;\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n  width: 250px; /* Adjust width */\n  display: flex;\n  gap:20px;\n  flex-direction: row; /* Align icon and content in a row */\n  align-items: center; /* Vertically align icon and text */\n}\n\n.icon {\n  font-size: 2.0rem;\n  margin-right:10px;/* Space between icon and text */\n}\n\n.custom-icon {\n  width: 50px;\n  height: 50px;\n   /* Space between icon and text */\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  text-align: left;\n  \n}\n\n.value {\n  font-size: 1.8rem;\n  font-weight: bold;\n  color: #3498db;\n  \n}\n\n.label {\n  font-size: 0.7rem;\n  color: #555;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
